<div class="animate__animated animate__fadeIn">
	<nz-input-group class="custom-amount {{ inputClass }}" [nzAddOnBefore]="addOnBeforeTemplate">
		<input
			type="text"
			[(ngModel)]="inputValue"
			[disabled]="disabled"
			(focusin)="setInputClass(1)"
			(focusout)="setInputClass(0)"
			(keyup)="formatNumber($event.target)"
			data-type="currency"
			placeholder=""
		/>
	</nz-input-group>
	<ng-template #addOnBeforeTemplate>
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M15.1723 4H18.3405V7.75684H21V10.6893H18.3405V13.2418H21V16.1742H18.3405V20H15.5913L13.1031 16.1742H8.93145V20H5.74854V16.1742H3V13.2418H5.74854V10.6893H3V7.75684H5.74854V4H8.54186L10.9679 7.75684H15.1723V4ZM15.1723 10.6893H12.8617L14.51 13.2418H15.1723V10.6893ZM11.1959 13.2418L9.53576 10.6893H8.93145V13.2418H11.1959Z"
				fill="#808080"
			/>
		</svg>
	</ng-template>
	<div *ngIf="showError && !showAmountRange" class="m-t-8">
		<div *ngIf="error" class="amount-error-message animate__animated animate__fadeIn">
			{{ errorMessage }}
		</div>
	</div>
</div>
